export const listAgentsConfig = () => ({
  url: `/superadmin/agent`,
});

export const getAgentConfig = (agentId) => ({
  url: `/superadmin/agent/${agentId}`,
});

export const createAgentConfig = () => ({
  url: `/superadmin/agent`,
});

export const updateAgentConfig = (agentId) => ({
  url: `/superadmin/agent/${agentId}`,
});

export const deleteAgentConfig = (agentId) => ({
  url: `/superadmin/agent/${agentId}`,
});
